import {
	getUTCStartDate,
	getUTCEndDate,
} from '../widgets/CustomDateRangePicker/CustomDateRangePicker.utils'

const startDate = new Date(import.meta.env.VITE_ALL_TIME_DATE) || new Date()

export const getDateRangeByDateFilter = (value) => {
	switch (value) {
		// TODO: Needs to update once the displayed engagement chart will be confirmed.
		// case 'Today': {
		// 	const today = new Date()
		// 	return [getUTCStartDate(today), getUTCEndDate(today)]
		// }
		// case 'Yesterday': {
		// 	const yesterday = new Date()
		// 	yesterday.setDate(yesterday.getDate() - 1)
		// 	return [getUTCStartDate(yesterday), getUTCEndDate(yesterday)]
		// }
		case 'This Week So Far': {
			const startDateOfWeek = new Date()
			const currentDay = startDateOfWeek.getDay()
			const endDateOfWeek = new Date()

			startDateOfWeek.setDate(startDateOfWeek.getDate() - currentDay)

			return [getUTCStartDate(startDateOfWeek), getUTCEndDate(endDateOfWeek)]
		}
		case 'Last Week': {
			const endDayOfLastWeek = new Date()
			endDayOfLastWeek.setDate(
				endDayOfLastWeek.getDate() - (endDayOfLastWeek.getDay() + 1)
			)
			const startDayOfLastWeek = new Date(endDayOfLastWeek)
			startDayOfLastWeek.setDate(endDayOfLastWeek.getDate() - 6)

			return [
				getUTCStartDate(startDayOfLastWeek),
				getUTCEndDate(endDayOfLastWeek),
			]
		}
		case 'This Month So Far': {
			const endDateOfMonth = new Date()
			const startDateOfMonth = new Date()
			startDateOfMonth.setDate(
				endDateOfMonth.getDate() - endDateOfMonth.getDate()
			)

			return [getUTCStartDate(startDateOfMonth), getUTCEndDate(endDateOfMonth)]
		}
		case 'Last Month': {
			const endDayOfLastMonth = new Date()
			endDayOfLastMonth.setDate(
				endDayOfLastMonth.getDate() - endDayOfLastMonth.getDate()
			)
			const startDayOfLastMonth = new Date(endDayOfLastMonth)
			startDayOfLastMonth.setDate(
				endDayOfLastMonth.getDate() - (endDayOfLastMonth.getDate() - 1)
			)

			return [
				getUTCStartDate(startDayOfLastMonth),
				getUTCEndDate(endDayOfLastMonth),
			]
		}
		case 'All Time': {
			return [getUTCStartDate(startDate), getUTCEndDate(new Date())]
		}
		default:
			return [getUTCStartDate(new Date()), getUTCEndDate(new Date())]
	}
}
